(function() {
    "use strict";

    if (!String.prototype.trim) {
        var regex = /^\s*(.*?)\s*$/;
        
        String.prototype.trim = function() {
            return this.replace(regex, "$1");
        };
    }
})();


// WEBPACK FOOTER //
// ./content/js/PrototypeExtensions/String.trim.js